import { render, staticRenderFns } from "./dui-gallery-vessel.vue?vue&type=template&id=511fe4e8&"
import script from "./dui-gallery-vessel.vue?vue&type=script&lang=js&"
export * from "./dui-gallery-vessel.vue?vue&type=script&lang=js&"
import style0 from "./dui-gallery-vessel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports